
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.37 47.31V36a4 4 0 10-8 0v11.31M40.64 47.31V36a4 4 0 10-8 0v11.31M.5 48.29h59M3.51 30.16l-1.76-5.23h56.49l-1.75 5.23","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M3.41 30.16h10.38v27.6H3.41zM56.59 57.76H46.21v-27.6h10.38zM13.8 30.08V13M46.2 30.08V13M13.88 57.76h32.24"}}),_c('path',{attrs:{"d":"M30 6a42.46 42.46 0 0117 3.52L45.93 12a40.1 40.1 0 00-31.86 0L13 9.52A42.46 42.46 0 0130 6m0-2a44.39 44.39 0 00-17.8 3.7l-1.83.8.79 1.83 1.08 2.47.76 1.83 1.84-.8a38.13 38.13 0 0130.26 0l1.84.8.79-1.84 1.08-2.47.79-1.83-1.83-.8A44.39 44.39 0 0030 4z","fill":"#241f21"}}),_c('path',{attrs:{"d":"M56.43 24.8v-5.87H34.74a4.74 4.74 0 00-9.48 0H3.57v5.93","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    